import React from 'react';

export default function KoronaCustomerFacingLandingPage(props) {
    return (
        <div>
            <h2>Thank You</h2>
        </div>
    )
}